// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!./../loader/justep-css-loader/index.js?{\"url\":true,\"import\":false,\"sourceMap\":false,\"modules\":false,\"minimize\":true}!./../../../../../tools/uix-web/node_modules/postcss-loader/index.js!./app.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!./../../../../../tools/uix-web/node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!./../loader/justep-css-loader/index.js?{\"url\":true,\"import\":false,\"sourceMap\":false,\"modules\":false,\"minimize\":true}!./../../../../../tools/uix-web/node_modules/postcss-loader/index.js!./app.css", function() {
			var newContent = require("!!./../loader/justep-css-loader/index.js?{\"url\":true,\"import\":false,\"sourceMap\":false,\"modules\":false,\"minimize\":true}!./../../../../../tools/uix-web/node_modules/postcss-loader/index.js!./app.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./pages/app.css
// module id = ./pages/app.css
// module chunks = 22